import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import "../App.css";
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu/index"
export default function Navheader(props) {
  const [navbar, setNavbar] = useState(false);

  const changebackground = () => {
    if (window.scrollY >= 9) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener('scroll', changebackground);
  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        fixed="top"
        bg="dark"
        variant="dark"
        className={navbar ? 'navbar active' : 'navbar'}
      >
        <Navbar.Brand>
          <a
            href="https://www.swmc.com"
            target="_blank"
            rel="noreferrer noopener"
            className="a-link"
          >
            <img
              src="https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"
              alt="Sun West Mortgage Logo"
              className="img-fluid w-50 main_logo"
            />
          </a>
        </Navbar.Brand>
          <UserWayAccessibilityMenu color="black" width={40} height={40} />
      </Navbar>
    </>
  );
} 